import { ResourcesInstanceConfig } from "../interfaces/resources-instance-config";
import { EnvironmentEnvironment } from "../interfaces/environment/environment-environment";
import { UserUsage } from "../interfaces/user-usage";

export const APP_CONFIG = (window as any)['APP_CONFIG'];

export const ENVIRONMENT_DEFAULTS = APP_CONFIG.ENVIRONMENT_DEFAULTS;
export const ENVIRONMENT_SIZE_MAX = APP_CONFIG.ENVIRONMENT_SIZE_MAX;
export const DESTINE_GW_URL=APP_CONFIG.DESTINE_GW_URL;
export const ASSETS_DEFAULTS=APP_CONFIG.ASSETS_DEFAULTS;
export const TOKEN_OVH=APP_CONFIG.TOKEN_OVH;
export const STANDARD_CPU_INSTANCES : ResourcesInstanceConfig[] = APP_CONFIG.STANDARD_CPU_INSTANCES;
export const DEFAULT_MAX_USER_USAGE : UserUsage = APP_CONFIG.DEFAULT_MAX_USER_USAGE;
export const INITIAL_CURRENT_USER_USAGE : UserUsage = APP_CONFIG.INITIAL_CURRENT_USER_USAGE;

export const STOP_QUOTA_MESSAGE = APP_CONFIG.STOP_QUOTA_MESSAGE;
export const START_QUOTA_MESSAGE = APP_CONFIG.START_QUOTA_MESSAGE;
export const DELETE_MESSAGE = APP_CONFIG.DELETE_MESSAGE;
export const SOMETHING_WENT_WRONG_MESSAGE=APP_CONFIG.SOMETHING_WENT_WRONG_MESSAGE;

export const ENVIRONMENT_TARGET_STATUSES = APP_CONFIG.ENVIRONMENT_TARGET_STATUSES;
export const ENVIRONMENT_TRANSITIONAL_STATUSES = APP_CONFIG.ENVIRONMENT_TRANSITIONAL_STATUSES;
export const DOCUMENTATION_HEADER_LINK=APP_CONFIG.DOCUMENTATION_HEADER_LINK;
export const ENVIRONMENT_STATUS_LABELS: Record<string, string> =APP_CONFIG.ENVIRONMENT_STATUS_LABELS;
export const GATEWAY_ERROR_MESSAGE=APP_CONFIG.GATEWAY_ERROR_MESSAGE;
export const USE_PROXY=APP_CONFIG.USE_PROXY;
export const ENVIRONMENT_RUNNING_RELEVANT_STATUSES=APP_CONFIG.ENVIRONMENT_RUNNING_RELEVANT_STATUSES;
export const ENVIRONMENT_STOPPED_RELEVANT_STATUSES=APP_CONFIG.ENVIRONMENT_STOPPED_RELEVANT_STATUSES;
export const ENVIRONMENT_CPU_RELEVANT_STATUSES=APP_CONFIG.ENVIRONMENT_CPU_RELEVANT_STATUSES;
export const ENVIRONMENT_STORAGE_RELEVANT_STATUSES=APP_CONFIG.ENVIRONMENT_STORAGE_RELEVANT_STATUSES;
export const DELETE_FAILED_ENVIRONMENTS=APP_CONFIG.DELETE_FAILED_ENVIRONMENTS;
export const UPDATE_STATUS_DELAY=APP_CONFIG.UPDATE_STATUS_DELAY;
export const SERVICE_SHORT_DESCRIPTION=APP_CONFIG.SERVICE_SHORT_DESCRIPTION;

export const SERVICE_FULL_DESCRIPTION_1=APP_CONFIG.SERVICE_FULL_DESCRIPTION_1;
export const SERVICE_FULL_DESCRIPTION_2=APP_CONFIG.SERVICE_FULL_DESCRIPTION_2;
export const SERVICE_FULL_DESCRIPTION_3=APP_CONFIG.SERVICE_FULL_DESCRIPTION_3;
export const AIFS_PAGE = APP_CONFIG.AIFS_PAGE;